import { Component, Input } from '@angular/core';
import { CountryReport } from '@shared/meta-data/sales-tax-report.meta';
import {
  countryNexusQueryParams,
  countryNexusRouterLink,
  countrySalesReportRouterLink,
} from '@app/utils/country-sales-report-route';

@Component({
  selector: 'app-country-tax-card',
  templateUrl: './country-tax-card.component.html'
})
export class CountryTaxCardComponent {
  @Input() collecting: boolean;
  @Input() report: CountryCodeName;
  @Input() startDate: string;
  @Input() endDate: string;

  get salesReportLink(): string[] {
    return countrySalesReportRouterLink(this.report?.code || '');
  }

  get countryNexusLink(): string[] {
    return countryNexusRouterLink(this.report?.code || '');
  }

  get countryNexusQueryParams(): { region?: string } {
    return countryNexusQueryParams(this.report?.code || '');
  }

  get taxAmount(): number {
    const r = this.report?.reports;
    if (!r) return 0;
    return Number(r.total_sales_tax ?? r.country_tax ?? r.total_sales_tax_due ?? 0);
  }
}

export interface CountryCodeName extends CountryReport {
  code: string;
  name: string;
}
